module.exports = __webpack_public_path__ + "static/media/03.Foreign Tour.48286a9e.JPG";